import { ReactNode } from "react";
import { Box, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

type Label = ReactNode;
type HelpText = ReactNode;

interface HeaderWithHelpOptions {
  tooltipEnterTouchDelay?: number;
  tooltipFontSize?: number | string;
}

/**
 * Renders a grid header label with a help icon/tooltip.
 * Keeps header content compact while surfacing inline guidance.
 */
export const headerWithHelp = (
  label: Label,
  helpText: HelpText,
  options?: HeaderWithHelpOptions
) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <b>{label}</b>
    <Tooltip
      title={helpText}
      enterTouchDelay={options?.tooltipEnterTouchDelay ?? 0}
      arrow
      componentsProps={{
        tooltip: { sx: { fontSize: options?.tooltipFontSize ?? "0.95rem" } },
      }}
    >
      <HelpOutlineIcon fontSize="small" color="action" />
    </Tooltip>
  </Box>
);
